<template>
    <span>
                   <v-layout row style="width:100%">

                                         

                          <v-flex xs2 style="text-align:right" class="pr-1 pt-3">
                            <v-spacer></v-spacer>
                            {{date|date}}
                          </v-flex>
                            <v-spacer></v-spacer>

                  <v-list-tile avatar>
                            

                            <v-list-tile-content  class="collection-list-ie" >
                              <v-list-tile-title v-html="user.displayName"></v-list-tile-title>
                                <v-list-tile-title v-if="user.email"  class="grey--text text--lighten-1">{{user.email}}</v-list-tile-title>
              <v-list-tile-title v-else style="color:white"   v-html=" '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + provider(user) + '</span>' "></v-list-tile-title>
                              
                            </v-list-tile-content>
                                      <v-list-tile-avatar v-if=" user.picture">
                              
                              <img v-if="user.picture.url" :src="user.picture.url+'_profile'" alt="avatar">
                              <img v-else :src="user.picture" alt="avatar">
                            </v-list-tile-avatar>

                            
                            <v-list-tile-avatar v-else >
                              
                              <img src="../../assets/user-icon.png" alt="" class="avatarImg1">
                            </v-list-tile-avatar>
                          </v-list-tile>

 

                          </v-layout>


                      <v-container>
                          <div style="width:100%" class="pl-4 ma-3 mb-5">
              <p class="pl-5 pr-5" v-html="message" style="white-space: pre-line; width:100%"></p>
                          </div>
                      </v-container>
                          <v-divider></v-divider>
        </span>
</template>

<script>
export default {
    methods:{
        provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";
      else if (user.hasOwnProperty("google")) return "Google";
      else if (user.hasOwnProperty("live")) return "Microsoft Live";
      else return "Local Register";
    }
  },
    props:['user','message','date']
  
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/MessageTemplateLeft.vue